import { Card, CardContent, Typography, Avatar, Stack, Button, Box, Chip, Tooltip } from '@material-ui/core';
import DescriptionIcon from '@mui/icons-material/Description';
import Label from './Label';
import { UserMoreMenu } from './_dashboard/user';

export default function UserCard({ user, handleGenerateQR, handleAction, onNameClick }) {
  const { _id, firstName, displayName, lastName, email, phone, role, isOnBoarded, company, image, isVerified, documentStatus, documentCounts } = user;
  let name = `${firstName} ${lastName}`;
  if (firstName === null || lastName === null) {
    name = displayName;
  }

  const getDocumentStatusLabel = (status, counts) => {
    if (!status || status === 'unknown' || status === 'error') {
      return (
        <Tooltip title="Unknown document status">
          <Chip 
            icon={<DescriptionIcon />} 
            label="Unknown" 
            color="default" 
            size="small" 
          />
        </Tooltip>
      );
    }
    
    if (status === 'missing') {
      return (
        <Tooltip title={`Missing required documents (${counts?.missing || '?'})`}>
          <Chip 
            icon={<DescriptionIcon />} 
            label={`Missing (${counts?.missing || '?'})`} 
            color="default" 
            size="small" 
          />
        </Tooltip>
      );
    }
    
    if (status === 'pending_approval') {
      return (
        <Tooltip title={`${counts?.pending || '?'} document(s) pending review`}>
          <Chip 
            icon={<DescriptionIcon />} 
            label={`Pending (${counts?.pending || '?'})`} 
            color="warning" 
            size="small" 
          />
        </Tooltip>
      );
    }
    
    if (status === 'rejected') {
      return (
        <Tooltip title={`${counts?.rejected || '?'} document(s) rejected`}>
          <Chip 
            icon={<DescriptionIcon />} 
            label={`Rejected (${counts?.rejected || '?'})`} 
            color="error" 
            size="small" 
          />
        </Tooltip>
      );
    }
    
    if (status === 'expired') {
      return (
        <Tooltip title={`${counts?.expired || '?'} document(s) expired`}>
          <Chip 
            icon={<DescriptionIcon />} 
            label={`Expired (${counts?.expired || '?'})`} 
            color="error" 
            size="small" 
          />
        </Tooltip>
      );
    }
    
    if (status === 'approved') {
      return (
        <Tooltip title="All documents approved">
          <Chip 
            icon={<DescriptionIcon />} 
            label="Approved" 
            color="success" 
            size="small" 
          />
        </Tooltip>
      );
    }
    
    return null;
  };

  return (
    <Card key={_id} sx={{ mb: 2 }}>
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar alt={name} src={image} />
          <Typography 
            variant="h6" 
            component="div"
            onClick={onNameClick}
            sx={{ 
              textDecoration: 'underline', 
              cursor: 'pointer',
              '&:hover': {
                color: 'primary.main'
              }
            }}
          >
            {name}
          </Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          {email}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {company}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {phone}
        </Typography>
        <Box display="flex" justifyContent="space-between" flexWrap="wrap" mt={1}>
            <Label variant="ghost" color={'info'}>
            Role: {role === 1 ? 'Store' : 'Employee'}
            </Label>
            <Label variant="ghost">
            Verified: {isVerified ? 'Yes' : 'No'}
            </Label>
            <Label variant="ghost" color={!isOnBoarded ? 'error' : 'success'}>
            Onboarded: {isOnBoarded ? 'Complete' : 'Incomplete'}
            </Label>
        </Box>
        
        {documentStatus && (
          <Box mt={1} display="flex" alignItems="center">
            <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
              Documents:
            </Typography>
            {getDocumentStatusLabel(documentStatus, documentCounts)}
          </Box>
        )}
        
        <Box mt={2} display="flex" justifyContent="space-between">
          <Button size="small" id={_id} value={name} onClick={(e) => handleGenerateQR(e)}>Generate QR</Button>
          <UserMoreMenu 
            id={_id} 
            action={handleAction} 
          />
        </Box>
      </CardContent>
    </Card>
  );
}
